import { useLottie } from 'lottie-react'
import player from '#app/assets/json/audio-player.json'

export const Player = () => {
	const style = {
		height: 80,
	}

	const options = {
		animationData: player,
		loop: true,
		autoplay: true,
	}

	const { View } = useLottie(options, style)

	return <>{View}</>
}
